<template>
  <div class="nav">
    <h2 class="title">{{msg}}</h2>
  </div>
</template>

<script>
export default {
  name: 'Nav',
  props: {
    msg: String
  }
}
</script>

<style lang="scss" scoped>
.nav {
  background-color: rgb(255, 255, 255);
  box-shadow: 0px 7px 9px 0px rgba(0, 0, 0, 0.09);
  width: 750px;
  height: 94px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;

  h2 {
    &.title {
      color: rgba(1, 1, 1, 0.871);
      font-size: 32px;
      font-weight: bold;
      text-align: center;
      margin: 0;
      line-height: 94px;
    }
  }
}
</style>
